import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useOperatorListSearchForm = () => {
  //////////////////////////////////////////////////////////////////////////////
  // 絞込み条件
  //////////////////////////////////////////////////////////////////////////////
  const searchConditionId = ref<string>("");
  const searchConditionName = ref<string>("");

  return {
    searchConditionId,
    searchConditionName,
  };
};
